var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.210236C6.15712 0.210236 4.84439 0.608447 3.72782 1.35451C2.61125 2.10058 1.74099 3.161 1.22709 4.40166C0.713192 5.64233 0.578733 7.00752 0.840717 8.3246C1.1027 9.64168 1.74936 10.8515 2.69893 11.8011C3.64849 12.7506 4.85831 13.3973 6.17539 13.6593C7.49247 13.9213 8.85766 13.7868 10.0983 13.2729C11.339 12.759 12.3994 11.8887 13.1455 10.7722C13.8915 9.6556 14.2898 8.34287 14.2898 6.99999C14.2878 5.19984 13.5718 3.47399 12.2989 2.2011C11.026 0.928205 9.30015 0.212221 7.5 0.210236ZM10.3463 9.84549C10.2667 9.92499 10.1588 9.96965 10.0463 9.96965C9.93375 9.96965 9.82585 9.92499 9.74625 9.84549L7.2 7.29924C7.16054 7.25987 7.12923 7.21312 7.10787 7.16164C7.0865 7.11016 7.07551 7.05497 7.0755 6.99924V3.18024C7.0755 3.06765 7.12023 2.95968 7.19984 2.88007C7.27945 2.80046 7.38742 2.75574 7.5 2.75574C7.61259 2.75574 7.72056 2.80046 7.80017 2.88007C7.87978 2.95968 7.9245 3.06765 7.9245 3.18024V6.82374L10.3463 9.24549C10.4257 9.32518 10.4702 9.43314 10.47 9.54564C10.4699 9.65814 10.4251 9.76599 10.3455 9.84549H10.3463Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.faefe7cc6277ef31162762f2902badf4.svg";
export { ForwardRef as ReactComponent };